export default "__VITE_ASSET__Dv8I$G64__"